export const navbar = {
  officeName: '大家行政書士事務所',
  home: 'ホーム',
  services: 'サービス内容',
  pricing: '料金体系',
  testimonials: 'お客様の声',
  contact: 'お問い合わせ',
  faq: 'よくあるご質問',
  freeConsultation: '無料相談',
};

export const hero = {
  chineseSupport: '中国語対応可能',
  title: '大家行政書士事務所',
  subtitle: '中国語が話せる担当者による安心・確実なサポート',
  description: 'ビザ申請から会社設立まで、中国人のお客様に特化した専門サービスを提供',
  bookConsultation: '無料相談予約',
  serviceDetails: 'サービス詳細',
  feature1Title: '中国語完全対応',
  feature1Desc: '中国語が話せる担当者が直接対応',
  feature2Title: '安心の実績',
  feature2Desc: '多くの中国人の方の手続きを成功サポート',
  feature3Title: '迅速対応',
  feature3Desc: '24時間以内のレスポンス保証',
};

export const services = {
  title: '中国語対応サービス',
  subtitle: '中国語が話せる行政書士が、中国人の方特有のニーズを理解し、母国語で安心してご相談いただけるサービスを提供いたします',
  service1Title: 'ビザ・在留資格申請',
  service1Desc: '就労ビザ、家族滞在、永住権申請など、中国人の方の在留資格に関する手続きを中国語でサポート',
  service2Title: '会社設立・経営支援',
  service2Desc: '中国人の方の起業をトータルサポート。設立から経営管理ビザの取得まで中国語で対応',
  service3Title: '建設業許可申請',
  service3Desc: '中国人経営者の建設業参入をサポート。許可要件から申請まで中国語で詳しく説明',
  service4Title: '帰化申請サポート',
  service4Desc: '日本国籍取得を目指す中国人の方へ。複雑な帰化手続きを中国語で丁寧にサポート',
  service5Title: '運送業許可申請',
  service5Desc: '中国人の方の運送業進出をサポート。許可取得から開始まで中国語で対応',
  service6Title: '各種許認可申請',
  service6Desc: '飲食店営業許可、古物商許可など、中国人の方のビジネスに必要な各種許認可を中国語サポート',
  chineseSupportTitle: '中国語完全対応',
  chineseSupportDesc: '中国語が話せる担当者が初回相談から手続き完了まで完全サポート。複雑な法的内容も母国語で詳しくご説明いたします。',
  chineseConsultation: '中国語相談',
  chineseConsultationDesc: '初回から中国語で詳しく相談可能',
  documentTranslation: '書類翻訳',
  documentTranslationDesc: '中国語書類の日本語翻訳対応',
  support24h: '24時間対応',
  support24hDesc: '中国語での緊急相談も可能',
  consultInChinese: '中国語で無料相談',
};

export const pricing = {
  title: '料金体系',
  subtitle: '透明で分かりやすい料金設定で安心してご依頼いただけます',
  category1: 'ビザ・在留資格',
  category2: '会社設立',
  category3: '建設業許可',
  category4: '帰化申請',
  category5: 'その他許可',
  freeConsultationTitle: '初回相談無料',
  freeConsultationDesc: 'お客様のご要望を詳しくお聞きした上で、正確な料金と手続きの流れをご提案いたします',
  quickResponse: '迅速対応',
  quickResponseDesc: '24時間以内にご回答',
  expertise: '専門性',
  expertiseDesc: '豊富な実績と経験',
  carefulSupport: '丁寧サポート',
  carefulSupportDesc: '最後まで責任を持って',
  bookFreeConsultation: '無料相談を予約する',
  note1: '※ 上記料金は参考価格です。案件の複雑さにより変動する場合があります',
  note2: '※ 官公署手数料、翻訳料、公証費用等の実費は別途必要です',
};

export const testimonials = {
  title: 'お客様の声',
  testimonialsTitle: 'お客様の声',
  subtitle: '中国語で安心してご相談いただけるサービスにより、多くの中国人の方に満足していただいております',
  client1Name: '李 明华',
  client1Role: 'IT企業経営者',
  client1Content: '経営管理ビザの申請で相談しました。中国語で詳しく説明していただき、複雑な手続きも安心して進められました。おかげで会社設立から在留資格取得まで全てスムーズに完了できました。',
  client2Name: '王 美玲',
  client2Role: '飲食店オーナー',
  client2Content: '飲食店開業のための許可申請をお願いしました。中国語で相談できるので、細かな質問も遠慮なくできました。開業まで手厚くサポートしていただき、本当に感謝しています。',
  client3Name: '張 健',
  client3Role: '建設会社代表',
  client3Content: '建設業許可の取得で困っていましたが、中国語が話せる先生に出会えて本当に良かったです。許可要件から申請書類まで、全て中国語で丁寧に説明していただき、無事許可を取得できました。',
  client4Name: '陈 小红',
  client4Role: '永住権取得者',
  client4Content: '永住権申請で8年間お世話になりました。中国語での相談ができるので、微妙なニュアンスまで正確に伝えることができ、申請書類も完璧に準備していただきました。無事に永住権を取得できました。',
  client5Name: '刘 強',
  client5Role: '運送業経営者',
  client5Content: '運送業許可の申請をお願いしました。中国語で法規制について詳しく教えていただき、事業計画も一緒に作成していただきました。許可取得後の運営についてもアドバイスをいただき、とても助かりました。',
  client6Name: '黄 婷婷',
  client6Role: '帰化申請者',
  client6Content: '帰化申請の手続きでお世話になりました。中国の戸籍関係の書類準備から面接対策まで、全て中国語でサポートしていただきました。複雑な手続きでしたが、安心してお任せできました。',
  chineseStaffTitle: '中国語が話せる担当者が直接対応',
  chineseStaffDesc: '言葉の壁を感じることなく、複雑な法的手続きについても母国語で安心してご相談いただけます。中国人特有のニーズを理解した専門家が、最適なソリューションをご提案いたします。',
  tag1: '中国語対応',
  tag2: '専門知識',
  tag3: '迅速対応',
  tag4: '豊富な実績',
};

export const contact = {
  title: 'お問い合わせ',
  subtitle: 'お気軽にご相談ください。24時間以内にご回答いたします。日本語、英語での対応が可能です。',
  officeLocation: '事務所所在地',
  address: '〒162-0811\n東京都新宿区水道町3-14\n神楽坂Nビル 2-M',
  phoneConsultation: 'お電話でのご相談',
  businessHours: '営業時間：9:00-18:00（月曜日〜金曜日）',
  emailConsultation: 'メールでのご相談',
  emailResponse: '24時間以内にご返信',
  accessTitle: 'アクセス',
  access1: '東京メトロ東西線「神楽坂駅」徒歩5分',
  access2: '都営大江戸線「牛込神楽坂駅」徒歩8分',
  access3: 'JR「飯田橋駅」徒歩10分',
  formTitle: 'オンライン相談フォーム',
  successMessage: '送信完了！',
  successDesc: 'お問い合わせを受け付けました。24時間以内にご回答いたします。',
  errorMessage: '送信に失敗しました',
  errorDesc: 'しばらく時間をおいて再度お試しいただくか、お電話でご連絡ください。',
  nameLabel: 'お名前',
  namePlaceholder: 'お名前をご入力ください',
  emailLabel: 'メールアドレス',
  emailPlaceholder: 'example@email.com',
  phoneLabel: 'お電話番号',
  phonePlaceholder: '090-1234-5678',
  serviceLabel: 'ご相談内容',
  servicePlaceholder: 'サービスをお選びください',
  serviceOption1: 'ビザ・在留資格',
  serviceOption2: '会社設立・経営',
  serviceOption3: '建設業許可',
  serviceOption4: '帰化申請',
  serviceOption5: '運送業許可',
  serviceOption6: 'その他許可申請',
  messageLabel: '詳細内容',
  messagePlaceholder: 'ご相談の詳細内容をご記入ください（500文字以内）',
  messageNote: '※ 500文字以内でご入力ください',
  submitting: '送信中...',
  submitButton: 'お問い合わせを送信',
  required: '*',
};

export const faq = {
  title: 'よくあるご質問',
  subtitle: 'よくあるご質問',
  q1: '中国語での相談は可能ですか？',
  a1: 'はい、中国語が話せる担当者が直接対応いたします。初回相談から手続き完了まで、全て中国語でサポート可能です。複雑な法的内容も母国語で詳しくご説明いたします。',
  q2: '中国の書類は日本語に翻訳する必要がありますか？',
  a2: 'はい、日本の行政機関に提出する書類は日本語翻訳が必要です。当事務所では中国語書類の翻訳サービスも提供しており、正確な翻訳と認証手続きもお任せいただけます。',
  q3: 'ビザ申請にはどのくらいの期間がかかりますか？',
  a3: 'ビザの種類により異なりますが、就労ビザで1〜3ヶ月、永住権申請で6〜12ヶ月程度が目安です。書類準備から申請まで、中国語でスケジュールを詳しくご説明いたします。',
  q4: '会社設立と経営管理ビザを同時に進められますか？',
  a4: 'はい、可能です。会社設立手続きと経営管理ビザ申請を並行して進めることで、効率的に事業を開始できます。事業計画書の作成から申請まで、中国語で包括的にサポートいたします。',
  q5: '相談料金はいくらですか？',
  a5: '初回相談は無料です。その後の手続きについては、サービス内容に応じて明確な料金をご提示いたします。中国語での詳しい料金説明も行いますので、安心してご相談ください。',
  q6: '急ぎの手続きにも対応していただけますか？',
  a6: 'はい、緊急案件にも対応いたします。中国語での24時間以内レスポンス保証により、お急ぎの案件も迅速に対応いたします。まずは中国語でお電話ください。',
  q7: '建設業許可の要件を中国語で教えていただけますか？',
  a7: 'もちろんです。建設業許可の複雑な要件について、中国語で詳しくご説明いたします。経営業務管理責任者や専任技術者の要件、財産的基礎など、全て母国語で理解していただけます。',
  q8: '帰化申請の成功率はどの程度ですか？',
  a8: '当事務所では中国人の帰化申請において95%以上の成功率を誇ります。中国の戸籍制度を熟知した専門家が、書類準備から面接対策まで中国語で完全サポートいたします。',
  ctaTitle: 'その他のご質問は中国語でお気軽に',
  ctaDesc: '上記以外にもご不明な点がございましたら、中国語で詳しくご説明いたします。どんな小さなことでも遠慮なくご相談ください。',
  ctaButton: '中国語で無料相談',
};

export const footer = {
  tagline: 'お客様の信頼できる法的パートナー',
  servicesTitle: 'サービス内容',
  service1: 'ビザ・在留資格',
  service2: '会社設立',
  service3: '建設業許可',
  service4: '帰化申請',
  officeInfoTitle: '事務所情報',
  pricing: '料金体系',
  testimonials: 'お客様の声',
  faq: 'よくあるご質問',
  contact: 'お問い合わせ',
  contactTitle: '連絡先',
  copyright: '© 2024 大家行政書士事務所. All rights reserved.',
  poweredBy: 'Powered by Readdy',
};

const ja = {
  ...navbar,
  ...hero,
  ...services,
  ...pricing,
  ...testimonials,
  ...contact,
  ...faq,
  ...footer,
};

export default ja;